import { render, staticRenderFns } from "./summary-inventory-list.vue?vue&type=template&id=7787c5f6&"
import script from "./summary-inventory-list.vue?vue&type=script&lang=js&"
export * from "./summary-inventory-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports